// Application root: query client + auth provider, then either the login screen
// or the authenticated router.

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth.js';
import { LoginPage } from './pages/LoginPage.js';
import { router } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, refetchOnWindowFocus: false } },
});

function AppRoutes() {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return <div className="full-page">Loading…</div>;
  }
  if (!user) {
    return <LoginPage />;
  }
  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </QueryClientProvider>
  );
}
